import styles from './Motability7List.module.scss';
import React from 'react';

export default function List({ slide }) {
  return (
    <ul className={styles.list} data-aos="fade-up">
      {slide.description?.map((feature, index) => (
        <li
          key={index}
          className={styles.list_block}
          data-aos="fade-up"
          data-aos-duration={(index + 1) * 500}
        >
          <h3 className={styles.list_block_title}>{feature.title}</h3>
          <p className={styles.list_block_text}>{feature.text}</p>
        </li>
      ))}
    </ul>
  );
}
